import { useState, useEffect } from "react";

import Config from "../../Config";

import empty_user from "../../empty_user.png";

import superx from "../../superx.png";

function WallLike(props)
{

        const REACTIONS = [
        { typ: 1, icon: '👍', label: 'Lubię to' },
        { typ: 2, icon: '❤️', label: 'Super' },
        { typ: 3, icon: '😂', label: 'Haha' },
        { typ: 4, icon: '😮', label: 'Wow' },
        { typ: 5, icon: '😢', label: 'Smutne' },
        { typ: 6, icon: '👏', label: 'Brawo' },
        { typ: 7, icon: '😟', label: 'Oh oh' },
        { typ: 8, icon: '😎', label: 'Luzik' },
        { typ: 9, icon: '👀', label: 'Że co...' },
        { typ: 10, icon: '😍', label: 'Kocham to' },
        { typ: 11, icon: '👌', label: 'Tak dalej' },
    ];




    const[tab,setTab] = useState(props.tab);
    const[view,setView] = useState("line");
    const[pickerOpen,setPickerOpen] = useState(false);


    const changeView = () => {
        if(view == "line")  {setView("list");} else setView("line");
    }

    const getReaction = (typ) => {
        return REACTIONS.find( (r) => r.typ == typ ) || REACTIONS[0];
    }


    const sendReaction = (typ, operacja) => {

            props.mainView.setProgress(-2);

            var req = {
                id: props.typId,
                typ: '' + typ,
                operacja: operacja
            };

            fetch( Config.url + '/rest_v1_news,set_like', {
                method: 'POST',
                body: JSON.stringify(req),
                headers: {
                    'Content-Type': 'application/json',
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => {

                        props.mainView.setProgress(-1);
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);
                        }else
                        {
                            setTab(res.result);
                        }
             } )
             .catch(err => {
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
             });

    }


    var persons = tab.length;

    var myReaction = null;

    for(var k=0; k<tab.length; k++)
    {
        if(tab[k].wlasciciel == '1') myReaction = tab[k];
    }

    var iLikeIt = myReaction != null;


    const toggleLike = () => {
        if(iLikeIt)
        {
            sendReaction(myReaction.typ, '0');
        }else
        {
            sendReaction(REACTIONS[0].typ, '1');
        }
    }

    const pickReaction = (typ) => {
        setPickerOpen(false);
        if(iLikeIt && myReaction.typ == typ)
        {
            sendReaction(typ, '0');
        }else
        {
            sendReaction(typ, '1');
        }
    }


    var likeIt = <img  src={superx} onClick={toggleLike} className="likebtn" />

    if(iLikeIt)
    {
        var myReactionInfo = getReaction(myReaction.typ);
        likeIt = <span onClick={toggleLike} className="likebtn current_reaction" title={myReactionInfo.label}>{myReactionInfo.icon}</span>
    }


    var reactionPicker = <div className="reaction_wrapper" onMouseEnter={ () => setPickerOpen(true) } onMouseLeave={ () => setPickerOpen(false) }>
                                {likeIt}
                                {
                                    pickerOpen &&
                                    <div className="reaction_picker shadowx">
                                        {
                                            REACTIONS.map( (r) => {
                                                return <span key={r.typ} className="reaction_option" title={r.label} onClick={ () => pickReaction(r.typ) }>{r.icon}</span>
                                            } )
                                        }
                                    </div>
                                }
                          </div>


    if(view == "list")
    {
        return (
            <div className="item_like" >
            {reactionPicker}  Reakcji: {persons} <span onClick={changeView} className="link_color">-ukryj-</span>

                <div className="quickPopup shadowx">

                        {  tab.map(  (item, ix) => {

                                var defAwatar =           <img  src={empty_user} />
                                if(item.awatar.length> 10) defAwatar=<img  src={ "data:image/jpeg;base64, " + item.awatar} />

                                var itemReaction = getReaction(item.typ);

                                return <div className="qitem" key={ix}>
                                    {defAwatar}  {item.imie} {item.nazwisko} <span className="reaction_tag" title={itemReaction.label}>{itemReaction.icon}</span>
                                </div>

                        } ) }

              </div>


            </div>
        )

    }


    return (
        <div className="item_like" >
              {reactionPicker}  Reakcji: {persons} <span onClick={changeView} className="link_color">-pokaż-</span>
        </div>
    )
}

export default WallLike;
